import Section from '../shared/Section';
import Field from '../shared/Field';
import Input from '../shared/Input';
import Select from '../shared/Select';
import Grid from '../shared/Grid';

const GENDER_OPTIONS = [
  { value: '', label: 'Unknown' },
  { value: 'M', label: 'Male' },
  { value: 'F', label: 'Female' },
];

const REL_OPTIONS = [
  { value: '18', label: 'Self' },
  { value: '01', label: 'Spouse' },
  { value: '19', label: 'Child' },
  { value: 'G8', label: 'Other' },
];

/**
 * @param {{
 *   claim: any,
 *   setField: (path: string, value: any) => void,
 *   editable: boolean,
 *   errorsByField: Map<string, any>,
 * }} props
 */
export default function SubscriberSection({ claim, setField, editable, errorsByField }) {
  const isSelf = (claim.patient_relationship_to_insured || '18') === '18';
  return (
    <Section icon="id-card" title="Subscriber & Insurance" subtitle="The individual who holds the insurance policy">
      <Grid cols={3}>
        <Field label="Relationship to Patient" required>
          <Select
            value={claim.patient_relationship_to_insured || '18'}
            options={REL_OPTIONS}
            onChange={(/** @type {any} */ v) => setField('patient_relationship_to_insured', v)}
            disabled={!editable}
          />
        </Field>
        <Field label="Subscriber First Name">
          <Input
            data-field="insured.first_name"
            value={claim.insured?.first_name || ''}
            onChange={(/** @type {any} */ e) => setField('insured.first_name', e.target.value)}
            disabled={!editable || isSelf}
          />
        </Field>
        <Field label="Subscriber Last Name">
          <Input
            data-field="insured.last_name"
            value={claim.insured?.last_name || ''}
            onChange={(/** @type {any} */ e) => setField('insured.last_name', e.target.value)}
            disabled={!editable || isSelf}
          />
        </Field>
        <Field label="Subscriber DOB">
          <Input
            type="date"
            data-field="insured.date_of_birth"
            value={claim.insured?.date_of_birth || ''}
            onChange={(/** @type {any} */ e) => setField('insured.date_of_birth', e.target.value)}
            disabled={!editable || isSelf}
          />
        </Field>
        <Field label="Subscriber Gender">
          <Select
            value={claim.insured?.gender || ''}
            options={GENDER_OPTIONS}
            onChange={(/** @type {any} */ v) => setField('insured.gender', v)}
            disabled={!editable || isSelf}
          />
        </Field>
        <Field label="Subscriber Address">
          <Input
            data-field="insured.address_line_1"
            value={claim.insured?.address_line_1 || ''}
            onChange={(/** @type {any} */ e) => setField('insured.address_line_1', e.target.value)}
            disabled={!editable || isSelf}
          />
        </Field>
        <Field label="Subscriber City">
          <Input
            data-field="insured.city"
            value={claim.insured?.city || ''}
            onChange={(/** @type {any} */ e) => setField('insured.city', e.target.value)}
            disabled={!editable || isSelf}
          />
        </Field>
        <Field label="Subscriber State">
          <Input
            data-field="insured.state"
            value={claim.insured?.state || ''}
            onChange={(/** @type {any} */ e) => setField('insured.state', e.target.value)}
            disabled={!editable || isSelf}
          />
        </Field>
        <Field label="Subscriber ZIP">
          <Input
            data-field="insured.zip_code"
            value={claim.insured?.zip_code || ''}
            onChange={(/** @type {any} */ e) => setField('insured.zip_code', e.target.value)}
            disabled={!editable || isSelf}
          />
        </Field>
        <Field label="Subscriber Phone">
          <Input
            data-field="insured.phone"
            value={claim.insured?.phone || ''}
            onChange={(/** @type {any} */ e) => setField('insured.phone', e.target.value)}
            disabled={!editable}
          />
        </Field>
        <Field label="Member ID" required caption="Box 1a — primary identifier" error={errorsByField?.get('insured.member_id')?.message}>
          <Input
            data-field="insured.member_id"
            value={claim.insured?.member_id || ''}
            onChange={(/** @type {any} */ e) => setField('insured.member_id', e.target.value)}
            disabled={!editable}
          />
        </Field>
        <Field label="Group Number">
          <Input
            data-field="insured.group_number"
            value={claim.insured?.group_number || ''}
            onChange={(/** @type {any} */ e) => setField('insured.group_number', e.target.value)}
            disabled={!editable}
          />
        </Field>
        <Field label="Prior Auth Number">
          <Input
            data-field="prior_authorization_number"
            value={claim.prior_authorization_number || ''}
            onChange={(/** @type {any} */ e) => setField('prior_authorization_number', e.target.value)}
            disabled={!editable}
          />
        </Field>
      </Grid>
    </Section>
  );
}
